import { clsx } from 'clsx'
import { useLatestCallback } from 'hook/useLatestCallback'
import { CSSProperties, SyntheticEvent, useState } from 'react'
import { fixImageUrl } from 'util/image'
import css from './Image.module.scss'

type Props = {
  className?: string
  fit?: boolean
  src: string
  style?: CSSProperties
  onLoad?(event: SyntheticEvent<HTMLImageElement>): void
  onError?(event: SyntheticEvent<HTMLImageElement>): void
  onRef?(element: HTMLImageElement | null): void
}

export const Image = (props: Props) => {
  const [good, setGood] = useState(false)
  const { fit, style } = props
  const className = clsx(props.className, !good && css.bad, fit && css.fit)
  const src = fixImageUrl(props.src)

  const onRef = useLatestCallback((element: HTMLImageElement | null) => {
    if (props.onRef) props.onRef(element)
  })

  const onLoad = useLatestCallback((event: SyntheticEvent<HTMLImageElement>) => {
    setGood(true)
    if (props.onLoad) props.onLoad(event)
  })

  const onError = useLatestCallback((event: SyntheticEvent<HTMLImageElement>) => {
    setGood(false)
    if (props.onError) props.onError(event)
  })

  return <img ref={onRef} className={className} style={style} src={src} alt=""
    onLoad={onLoad} onError={onError} />
}
